/**
 * Per-chain token address validation.
 * Returns null if valid, or an error string if invalid.
 */

const SOLANA_RE = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;
const EVM_RE = /^0x[0-9a-fA-F]{40}$/;

const EVM_CHAINS = new Set(["robinhood", "eth", "base", "bsc"]);

export function validateTokenAddress(value, chain) {
  const v = (value || "").trim();
  if (!v) return "Enter a token address.";
  if (chain === "solana") {
    return SOLANA_RE.test(v) ? null : "Enter a valid Solana mint address (base58, 32–44 chars).";
  }
  if (EVM_CHAINS.has(chain)) {
    return EVM_RE.test(v) ? null : "Enter a valid EVM contract address (0x + 40 hex chars).";
  }
  // fallback: accept anything
  return null;
}

export function isEvmChain(chain) {
  return EVM_CHAINS.has(chain);
}

export const CHAIN_LABELS = {
  solana: "Solana",
  robinhood: "Robinhood",
  eth: "Ethereum",
  base: "Base",
  bsc: "BSC",
  tron: "TRON",
  ton: "TON",
  hyperliquid: "Hyperliquid",
};

export function chainLabel(chain) {
  return CHAIN_LABELS[chain] || chain.charAt(0).toUpperCase() + chain.slice(1);
}
